import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import React from 'react';
import { Route } from 'react-router';

export const routes$ = {
    List: AsyncPageRender(() => pageModule(import('./List'))),
    Edit: AsyncPageRender(() => pageModule(import('./Edit'))),
    View: AsyncPageRender(() => pageModule(import('./View'))),
};

function Router() {
    return (
        <>
            <Route exact path={'/operations/products/skus/:sku'} component={ProtectedRoute(routes$.View)} />
            <Route exact path={'/operations/products/skus/:sku/edit'} component={ProtectedRoute(routes$.Edit)} />
            <Route exact path={'/operations/products/skus/:sku/edit/:tab'} component={ProtectedRoute(routes$.Edit)} />
        </>
    );
}

export default Router;
